window.GG = window.GG || {};

export default window.GG.matchMyMilesConfig;



// WEBPACK FOOTER //
// ./config/config.js